<template>
  <div
    class="lg:px-12 md:px-12 px-5 lg:mb-8 md:mb-4 mb-4 lg:py-16 md:py-12 py-8 bg-disclaimer"
  >
    <div class="container mx-auto">
      <div>
        <p class="text-primary text-lg font-semibold mb-2">Disclaimer</p>
        <p class="fsize14 mb-1">
          The information provided on this website is for educational purposes
          only and is not intended to be a substitute for professional medical
          advice, diagnosis, or treatment. 
        </p>
        <p class="fsize14 mb-1">
          Readers should seek professional medical advice and treatment for any
          specific health-related issues.
        </p>
        <p class="fsize14 mb-1">
          The information presented on this website is provided 'as is' without
          any representations or warranties, express or implied. The website
          owner and contributors disclaim all liability for any damages or
          losses arising from the use of this information.
        </p>
        <p class="fsize14 mb-1">
          As a caregiver, it can be difficult to cope with the diagnosis of
          {{ condition }} in a loved one. However, understanding what
          {{ condition }} is, the various forms of {{ condition }}, and what to
          look out for to detect it in the early stages can help you provide the
          best possible care for your loved one. Remember, early detection of
          {{ condition }} can improve the chances of successful treatment and
          recovery. If you notice any unusual symptoms or changes in your loved
          one's health, it is essential to consult a doctor immediately.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    condition() {
      const route = this.$route.name;

      if (route === "medical_cancer") {
        return "cancer";
      } else if (route === "medical_dementia") {
        return "dementia";
      } else if (route === "medical_palliative") {
        return "palliative";
      } else if (route === "medical_neurologicaldisorders") {
        return "neurological disorder";
      }
    },
  },
};
</script>
<style>
.bg-disclaimer {
  background: #cd4eaf1a;
}
</style>
